import {Component, effect, Input, input, model, output, signal, ViewEncapsulation} from '@angular/core';
import { CommonModule } from '@angular/common';
import {MatCardModule} from "@angular/material/card";
import {MatChipInputEvent, MatChipListboxChange, MatChipSelectionChange, MatChipsModule} from "@angular/material/chips";
import {MatButtonModule} from "@angular/material/button";
import {MatIconModule} from "@angular/material/icon";
import {MatFormField} from "@angular/material/form-field";
import {COMMA, ENTER} from "@angular/cdk/keycodes";
import {MatInputModule} from "@angular/material/input";

@Component({
  selector: 'app-step-2',
  standalone: true,
  imports: [CommonModule, MatCardModule, MatChipsModule, MatButtonModule, MatIconModule, MatFormField, MatInputModule],
  templateUrl: './step-2.component.html',
  styleUrl: './step-2.component.scss',

})
export class Step2Component {
  paymentPlan = model<any>('');
  coupon = model<any>('');
  selectedPlan = output<any>();
  addedCoupon = output<any>();
  currentIndex = signal(0);

  chips: string[] = [];
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  showPromoCode = false;
  private startX = 0;



  openId: string | null = null;


  constructor() {
    effect(() => {
        if(this.paymentPlan()){
          this.movePopularToMiddle();
        }
      },
      { allowSignalWrites: true } );
    effect(() => {
      if(this.coupon()) {
        const target = this.paymentPlan().find((item: any) => item.priceId === this.coupon().priceId);
        if (target) {
          target.oldReceipt = target.receipt;
          target.receipt = this.coupon().receipt;
        }
      }
    });
  }

  selectPlan(item: any){
    this.selectedPlan.emit(item);
  }



  add(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    if (value && this.chips.length < 1) {
      this.chips.push(value);
      this.addedCoupon.emit({coupon: value, priceId: this.openId});
    }
    // clear the input
    event.chipInput!.clear();
  }

  remove(chip: string, plan: any): void {
    const target = this.paymentPlan().find((item: any) => item.priceId === plan.priceId);
    target.receipt = target.oldReceipt;
    this.chips = this.chips.filter(c => c !== chip);
    this.coupon.set(null);
  }

  movePopularToMiddle(): void {
    this.paymentPlan.update(arr => {
      const popularIdx = arr.findIndex((p: any) => p.isPopular);
      if (popularIdx === -1 || popularIdx === 1) return arr;   // nothing to move

      const copy = [...arr];               // make a new array only if needed
      const [popular] = copy.splice(popularIdx, 1);
      copy.splice(1, 0, popular);
      return copy;                         // new reference → one extra effect run
    });
  }

  toggle(id: string) {
    this.chips = [];
    // if clicking the same one, close it; otherwise open the new one
    this.openId = this.openId === id ? null : id;
  }

  trackById(index: number, item: any): string {
    return item.id;
  }

  start(ev: PointerEvent) { this.startX = ev.clientX; }
  end(ev: PointerEvent) {
    const dx = ev.clientX - this.startX;
    if (dx > 40) this.onSwipeRight();        // right swipe
    else if (dx < -40) this.onSwipeLeft();   // left swipe
  }

  onSwipeLeft(): void {
    if (this.currentIndex() < this.paymentPlan().length - 1) {
      this.currentIndex.update(v => v + 1);
    }
  }

  onSwipeRight(): void {
    if (this.currentIndex() > 0) {
      this.currentIndex.update(v => v - 1);
    }
  }
}
